module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAKKADAAQAAAABAAAAKAAAAAB65masAAAAcElEQVRYCe2VQQoAIAgEo9/1/yf0kMqgU0ep1hhB6iKts6EpERCAAASuESjjpTqyPU7TYFq2UBC34JiWGXldIpzyFkeAiEYIQAACJwnID2p2sdd+eYu9DVIPAQhAIDoB+UHNLvZ+MXmLvQ1SD4EvCXT9JzhSnnKZVQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_mobile_menu.png
// module id = qzRU
// module chunks = 1